"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
const svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor'
  //'aria-hidden': 'true',
  //focusable: 'false',
};
var _default = exports.default = svgBaseProps;